import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  ConsentContainer,
  ConsentContent,
  ConsentText,
  ConsentButtons,
  AcceptButton,
  DeclineButton,
  PolicyLink,
  CloseButton
} from './styles';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Verifica se o usuário já aceitou os cookies
    const hasConsented = localStorage.getItem('floqss-cookie-consent');
    if (!hasConsented) {
      // Mostra o popup após 2 segundos
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('floqss-cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('floqss-cookie-consent', 'declined');
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <ConsentContainer>
      <ConsentContent>
        <CloseButton onClick={handleClose}>
          ×
        </CloseButton>
        <ConsentText>
          <strong>🍪 Utilizamos cookies y términos de uso</strong>
          <br />
          Utilizamos cookies para mejorar tu experiencia de navegación y personalizar el contenido. 
          Al continuar navegando, aceptas nuestras{' '}
          <PolicyLink as={Link} to="/centro-legal?section=privacidad">
            Políticas y Términos de Uso
          </PolicyLink>
          .
        </ConsentText>
        <ConsentButtons>
          <AcceptButton onClick={handleAccept}>
            Aceptar Todo
          </AcceptButton>
          <DeclineButton onClick={handleDecline}>
            Rechazar
          </DeclineButton>
        </ConsentButtons>
      </ConsentContent>
    </ConsentContainer>
  );
};

export default CookieConsent;